module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"pre_service.image_comment.front":"ด้านหน้า","pre_service.image_comment.back":"ด้านหลัง"}}')
  delete Component.options._Ctor
}
